import { withSlotWidths } from 'components/shared/DocumentSheet/lib/docStyles';

const ITEM_SLOTS = {
  code: 52,
  quantity: 32,
  price: 64,
  discount: 56,
  tax: 48,
  total: 74
};

export const ITEMS_TABLE_COLUMNS = ({ hasItems, canSeeAmounts, hasTaxModule }) => {
  const columns = [{ key: 'name', label: 'Item / service', align: 'left', strong: true }];

  if (hasItems) columns.push({ key: 'code', label: 'Code', align: 'left', tabular: true });
  if (hasItems) columns.push({ key: 'quantity', label: 'Qty', align: 'right', tabular: true });
  if (canSeeAmounts && hasItems)
    columns.push({ key: 'price', label: 'Price', align: 'right', tabular: true });
  if (hasItems) columns.push({ key: 'discount', label: 'Disc.', align: 'right', tabular: true });
  if (hasItems && hasTaxModule)
    columns.push({ key: 'tax', label: 'Tax', align: 'right', tabular: true });
  if (canSeeAmounts)
    columns.push({ key: 'total', label: 'Amount', align: 'right', strong: true, tabular: true });

  return withSlotWidths(columns, ITEM_SLOTS);
};
